var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-top":"6px"}},[_c('h2',{staticStyle:{"text-align":"center","font-family":"'Sofia'"}},[_vm._v("Hobbies Analysis")]),_c('Bar',{attrs:{"id":"my-chart-id","options":_vm.chartOptions,"data":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }